import { useState, useEffect } from 'react';

export const useDelay = (value, delay = 250) => {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (value) {
      const t = setTimeout(() => setShown(true), delay);
      return () => clearTimeout(t);
    } else {
      setShown(false);
    }
  }, [value, delay]);
  return shown;
};
